import React, { useEffect } from "react";
import classNames from "classnames";
import { PageLoadingProps } from "./PageLoading.types";
import styles from "./index.module.scss";
import { SpinnerIcon } from "@/components/Icon/IconSvgMap";
import { navigationPolicy } from "@/navigation/policy";
import { IonicBubblesLoading } from "./IonicBubblesLoading";

/**
 * PageLoading组件 - 页面加载组件
 * 使用SVG加载动画，带白色边框和渐变背景容器（Figma 设计）
 */
const PageLoading: React.FC<PageLoadingProps> = ({
  init = false,
  height,
  className,
  style,
  onUnmount,
}) => {
  // 组件卸载清理
  useEffect(() => {
    return () => {
      if (window._config) {
        window._config.loadingIcon = undefined;
      }
      onUnmount?.();
    };
  }, [onUnmount]);

  // supergol 等皮肤：按 navigation 轴的 loadingStyle 换成 Ionic ion-loading 形态（遮罩 + 小方盒 + 气泡 spinner）
  if (navigationPolicy.loadingStyle === "ionicBubbles") {
    return <IonicBubblesLoading className={className} style={style} />;
  }

  return (
    <div
      className={classNames(
        styles.root,
        {
          [styles.init]: init,
        },
        className
      )}
      style={{ height, ...style }}
    >
      <div className="gb-page-loading-icon" />

      <div className={styles.spinnerContainer}>
        <div className={styles.spinner}>
          <SpinnerIcon width={40} height={40} className={styles.loadingSvg} />
        </div>
      </div>
    </div>
  );
};

export default PageLoading;
